exports = module.exports = require("/Volumes/Work/ITCase/baikal430/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".Logo{font-size:1.3rem;line-height:1.8rem;text-transform:uppercase;cursor:pointer;-webkit-transition:color .3s;transition:color .3s}.Logo strong{font-size:3rem;font-weight:400;display:block;margin-left:-.2rem}", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader/lib!./~/stylus-loader!./src/components/Logo/Logo.styl
// module id = 213
// module chunks = 0